// Constants
import {
  PROP_ASSET,
  PROP_SHAPE_DATA,
  PROP_TYPE,
} from 'fc-model-fieldborder'
import { UPLOAD_FIELD_BORDERS } from '../constants'

// Libs
import _has from 'lodash/has'

// Ops
import fieldBordersOperator, { watchOperations } from 'fc-operator-fieldborder'

// Effects
import { fork, put, take } from 'redux-saga/effects'

// Selectors
import { uploadFieldBordersOperations$ } from 'hfty-assets-dom'

export default function *watchUploadOperations (): Generator<*, void, *> {
  while (true) {
    const {payload} = yield take([UPLOAD_FIELD_BORDERS])
    yield fork(watchOperations, { operations$: uploadFieldBordersOperations$ })
    yield fork(handleUploadBorders, payload)
  }
}

export function *handleUploadBorders (payload: Object): Generator<*, void, *> {
  // required: fieldId, 3 files (array) .shp, .shx, .dbf
  // const {payload} = yield take([UPLOAD_FIELD_BORDERS])
  const selectedId = payload.selectedId
  const source = _has(payload, 'source') ? payload.source : 'assets'
  if (selectedId !== undefined) {
    const operation = fieldBordersOperator.create({
      model: {
        [PROP_ASSET]: selectedId,
        [PROP_SHAPE_DATA]: [],
        [PROP_TYPE]: 'shp',
        source: source,
      },
    })
    yield put(fieldBordersOperator.actionCreators.add(operation))
  }
}
